import React from 'react';
import { useGlobalFaqDialog } from '@client/modules/Faq/FaqHelpCenter/FaqDialogProvider';
import { MenuPageContainer } from '@client/modules/MenuPage';

export function MenuPageWithFaqDialogContainer(props: any) {
  const openFaqDialog = useGlobalFaqDialog();
  return <MenuPageContainer {...props} openFaqDialog={openFaqDialog} />;
}
